<!-- eslint-disable -->
<template lang="pug">
    user-form(
        :user="user"
        :type="type"
        :submit="create"
        :is-password-required="true"
        :not-enough-money-on-account="notEnoughMoneyError"
    )
        template(slot="title")
            template {{ $i18n.t('user.user_createForm_admin') }}
        template(slot="button") {{ $i18n.t('user.user_createForm_create') }}
</template>

<script>
/*eslint-disable*/
import UserForm from '../user/RegistrationForm.vue'
import UserApi from '../../api/user/user'
export default {
    data() {
        return {
            type: 'admin',
            user: {
                lastName: '',
                firstName: '',
                sex: 'male',
                status: 'active',
                locale: 'ru',
                email: '',
                username: '',
                phone: '',
                password: '',
                passwordConfirmation: '',
                school: '',
                grades: [],
                courses: '',
                city: '',
                address: '',
                type: 'admin',
                parents: [
                    {
                        firstName: '',
                        lastName: '',
                        email: '',
                        phone: ''
                    },
                    {
                        firstName: '',
                        lastName: '',
                        email: '',
                        phone: ''
                    }
                ]
            },
            notEnoughMoneyError: false,
        }
    },
    methods: {
        create(user) {
            return UserApi.register(user)
                .then((data) => {
                    this.$router.push({name: 'login'})
                })
                .catch(err => {
                    if (err.data.errors) {
                        for (let key in err.data.errors) {
                            let error = err.data.errors[key];
                            this.$toasted.error(error[0]);
                        }
                    } else if (err.status !== 402) {
                        this.$toasted.error(err.data.message);
                    }
                })
        }
    },
    components: {
        UserForm
    }
}

</script>
